import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import memberApiProvider from "../apiProvider/memberApi";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/auth";

const UserRegisterMemberListLayer = () => {
    const navigate = useNavigate();
    const [resetStep, setResetStep] = useState(0);
    const [mobile, setMobile] = useState("");
    const [otp, setOtp] = useState("");
    const [username, setUsername] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const { id } = useParams();
    const [membersData, setMembersData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedMember, setSelectedMember] = useState(null);
    const [showMemberModal, setShowMemberModal] = useState(false);

    const handleResetClick = () => {
        setResetStep(1);
    };

    const handleSendOtp = () => {
        if (mobile.length >= 10) setResetStep(2);
        else alert("Enter a valid mobile number");
    };

    const handleVerifyOtp = () => {
        if (otp.length === 6) setResetStep(3);
        else alert("Enter valid 6-digit OTP");
    };

    const handleSavePassword = () => {
        if (newPassword !== confirmPassword) return alert("Passwords don't match!");
        setResetStep(4);
        setTimeout(() => {
            setResetStep(0);
            navigate("/sign-in");
        }, 3000);
    };

    const handleStatusChange = async (memberId, value) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: `You are about to ${value.toLowerCase()} this member`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `Yes, ${value} it!`,
            });

            if (result.isConfirmed) {
                // Call API to update member status
                const response = await memberApiProvider.updateMemberStatus(memberId, {
                    status: value === "Activate" ? "active" : "decline",
                });

                if (response && response.status) {
                    Swal.fire(
                        "Success!",
                        `Member has been ${value.toLowerCase()}.`,
                        "success"
                    );
                    fetchData();
                    // Update local state
                    // setMembersData(prevMembers =>
                    //     prevMembers.map(member =>
                    //         member._id === memberId ? {
                    //             ...member,
                    //             isActive: value === 'Activate' ? 1 : 0,
                    //             status: value === 'Activate' ? 'approved' : 'rejected'
                    //         } : member
                    //     )
                    // );
                }
            }
        } catch (error) {
            console.error("Error updating member status:", error);
            Swal.fire("Error!", "Failed to update member status.", "error");
        }
    };

    const handleViewMember = (member) => {
        setSelectedMember(member);
        setShowMemberModal(true);
    };

    const handleEditMember = (memberId) => {
        navigate(`/edit-primarymember/${memberId}`);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await memberApiProvider.getRegisterUserList();
            if (response && response.status) {
                setMembersData(response.data.data.members || []);
            }
        } catch (error) {
            console.error("Error fetching members:", error);
        } finally {
            setLoading(false);
        }
    };

    console.log(membersData, "membersDatamembersData");

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                <div className="d-flex align-items-center flex-wrap gap-3">
                    <form className="navbar-search">
                        <input
                            type="text"
                            className="bg-base h-40-px w-auto"
                            name="search"
                            placeholder="Search"
                        />
                        <Icon icon="ion:search-outline" className="icon" />
                    </form>

                    <select
                        className="form-select form-select-sm w-auto"
                        defaultValue="Select Number"
                    >
                        <option value="Select Number">This Week</option>
                        <option value="10">This Month</option>
                        <option value="15">Last Week</option>
                        <option value="20">Last Month</option>
                        <option value="20">This Term</option>
                    </select>
                </div>
                {/* {hasPermission("associates-create") && (
                    <Link
                        to="/add-primarymember"
                        className="btn btn-primary grip text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                    >
                        <Icon
                            icon="ic:baseline-plus"
                            className="icon text-xl line-height-1"
                        />
                        Add New
                    </Link>
                )} */}
            </div>

            <div className="card-body p-24">
                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div className="table-responsive scroll-sm">
                        <table className="table bordered-table sm-table mb-0">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Name</th>
                                    <th>Chapter name</th>
                                    <th>Company name</th>
                                    <th>Category</th>
                                    <th>Mobile Number</th>
                                    <th className="text-center">Status</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {membersData &&
                                    membersData.map((member, index) => (
                                        <tr key={member._id}>
                                            <td>{index + 1}.</td>
                                            <td>{member.name}</td>
                                            <td>{member.chapterInfo?.chapterId?.chapterName}</td>
                                            <td>{member.personalDetails.companyName}</td>
                                            <td>
                                                <span className="text-md mb-0 fw-normal text-secondary-light">
                                                    {member.personalDetails.categoryRepresented}
                                                </span>
                                            </td>
                                            <td>{member.contactDetails.mobileNumber}</td>
                                            <td className="text-center">
                                                <select
                                                    disabled={!hasPermission("associates-update")}
                                                    className={`form-select newonee form-select-sm w-auto radius-12 h-40-px custom-status-select ${member.status === "active"
                                                        ? "status-activate"
                                                        : member.status === "decline"
                                                            ? "status-decline"
                                                            : ""
                                                        }`}
                                                    value={
                                                        member.status === "active"
                                                            ? "Activate"
                                                            : member.status === "decline"
                                                                ? "Decline"
                                                                : "Select Status"
                                                    }
                                                    onChange={(e) =>
                                                        handleStatusChange(member._id, e.target.value)
                                                    }
                                                >
                                                    <option value="Activate">Activate</option>
                                                    <option value="Decline">Decline</option>
                                                </select>
                                            </td>
                                            <td className="text-center">
                                                <div className="d-flex align-items-center gap-10 justify-content-center">
                                                    {hasPermission("associates-list") && (
                                                        <button
                                                            type="button"
                                                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                            onClick={() => handleViewMember(member)}
                                                        >
                                                            <Icon
                                                                icon="majesticons:eye-line"
                                                                className="icon text-xl"
                                                            />
                                                        </button>
                                                    )}
                                                    {hasPermission("associates-update") && (
                                                        <button
                                                            type="button"
                                                            className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                            onClick={() => handleEditMember(member._id)}
                                                        >
                                                            <Icon icon="lucide:edit" className="menu-icon" />
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Member Details Modal */}
            <Modal
                show={showMemberModal}
                onHide={() => setShowMemberModal(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Member Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedMember && (
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <h6 className="text-muted">Personal Information</h6>
                                    <p>
                                        <strong>Name:</strong> {selectedMember.name}
                                    </p>
                                    <p>
                                        <strong>Date of Birth:</strong>{" "}
                                        {new Date(
                                            selectedMember.personalDetails.dob
                                        ).toLocaleDateString()}
                                    </p>
                                    <p>
                                        <strong>Education:</strong>{" "}
                                        {selectedMember.personalDetails.education}
                                    </p>
                                </div>

                                <div className="mb-3">
                                    <h6 className="text-muted">Chapter Information</h6>
                                    <p>
                                        <strong>Chapter:</strong>{" "}
                                        {selectedMember.chapterInfo?.chapterId?.chapterName}
                                    </p>
                                    <p>
                                        <strong>Zone:</strong>{" "}
                                        {selectedMember.chapterInfo?.zoneId?.zoneName}
                                    </p>
                                    <p>
                                        <strong>Invited By:</strong>{" "}
                                        {selectedMember.chapterInfo?.whoInvitedYou}
                                    </p>
                                </div>

                                <div className="mb-3">
                                    <h6 className="text-muted">Business Information</h6>
                                    <p>
                                        <strong>Company:</strong>{" "}
                                        {selectedMember.personalDetails.companyName}
                                    </p>
                                    <p>
                                        <strong>Industry:</strong>{" "}
                                        {selectedMember.personalDetails.industry}
                                    </p>
                                    <p>
                                        <strong>Category:</strong>{" "}
                                        {selectedMember.personalDetails.categoryRepresented}
                                    </p>
                                    <p>
                                        <strong>Years in Business:</strong>{" "}
                                        {selectedMember.businessDetails.yearsInBusiness.replace(
                                            /_/g,
                                            " "
                                        )}
                                    </p>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <h6 className="text-muted">Contact Details</h6>
                                    <p>
                                        <strong>Email:</strong>{" "}
                                        {selectedMember.contactDetails.email}
                                    </p>
                                    <p>
                                        <strong>Mobile:</strong>{" "}
                                        {selectedMember.contactDetails.mobileNumber}
                                    </p>
                                    <p>
                                        <strong>Secondary Phone:</strong>{" "}
                                        {selectedMember.contactDetails.secondaryPhone}
                                    </p>
                                    <p>
                                        <strong>Website:</strong>{" "}
                                        {selectedMember.contactDetails.website}
                                    </p>
                                    <p>
                                        <strong>GST Number:</strong>{" "}
                                        {selectedMember.contactDetails.gstNumber}
                                    </p>
                                </div>

                                <div className="mb-3">
                                    <h6 className="text-muted">Business Address</h6>
                                    <p>{selectedMember.businessAddress.addressLine1}</p>
                                    {selectedMember.businessAddress.addressLine2 && (
                                        <p>{selectedMember.businessAddress.addressLine2}</p>
                                    )}
                                    <p>
                                        {selectedMember.businessAddress.city},{" "}
                                        {selectedMember.businessAddress.state}
                                    </p>
                                    <p>
                                        Postal Code: {selectedMember.businessAddress.postalCode}
                                    </p>
                                </div>

                                {selectedMember.businessReferences &&
                                    selectedMember.businessReferences.length > 0 && (
                                        <div className="mb-3">
                                            <h6 className="text-muted">Business References</h6>
                                            {selectedMember.businessReferences.map((ref, index) => (
                                                <div key={index} className="mb-2">
                                                    <p>
                                                        <strong>
                                                            {ref.firstName} {ref.lastName}
                                                        </strong>
                                                    </p>
                                                    <p>Business: {ref.businessName}</p>
                                                    <p>Phone: {ref.phoneNumber}</p>
                                                    <p>Relationship: {ref.relationship}</p>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowMemberModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Password Reset Modal */}
            <Modal
                show={resetStep > 0}
                onHide={() => setResetStep(0)}
                backdrop="static"
                centered
                dialogClassName="custom-reset-modal"
            >
                <Modal.Body className="p-50 text-center" style={{ fontSize: "0.9rem" }}>
                    {resetStep === 1 && (
                        <>
                            <h6 className="mb-5">Enter Mobile Number</h6>
                            <input
                                type="text"
                                className="form-control mb-3 mx-auto shadow-sm border border-secondary rounded"
                                style={{ maxWidth: "300px" }}
                                placeholder="Mobile Number"
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                            />
                            <Button variant="primary grip" onClick={handleSendOtp}>
                                Send OTP
                            </Button>
                        </>
                    )}

                    {resetStep === 2 && (
                        <>
                            <h6 className="mb-5">Enter OTP</h6>
                            <input
                                type="text"
                                className="form-control mb-3 mx-auto shadow-sm border border-secondary rounded"
                                style={{ maxWidth: "300px" }}
                                placeholder="Enter OTP"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                            />
                            <Button variant="primary grip" onClick={handleVerifyOtp}>
                                Verify OTP
                            </Button>
                        </>
                    )}

                    {resetStep === 3 && (
                        <>
                            <h6 className="mb-5">Reset Password</h6>
                            <input
                                type="text"
                                className="form-control mb-3 mx-auto shadow-sm border border-secondary rounded"
                                style={{ maxWidth: "300px" }}
                                placeholder="User Name"
                                value="Anbu"
                                readOnly
                            />
                            <input
                                type="password"
                                className="form-control mb-3 pb-2 mx-auto shadow-sm border border-secondary rounded"
                                style={{ maxWidth: "300px" }}
                                placeholder="New Password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <input
                                type="password"
                                className="form-control mb-3 pb-2 mx-auto shadow-sm border border-secondary rounded"
                                style={{ maxWidth: "300px" }}
                                placeholder="Repeat Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                            <Button variant="success grip" onClick={handleSavePassword}>
                                Save
                            </Button>
                        </>
                    )}

                    {resetStep === 4 && (
                        <div>
                            <h6 className="mb-2">Password changed successfully!</h6>
                            <p>Redirecting to login...</p>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            <style>{`
                select.no-arrow {
                    background-image: none !important;
                }
                .status-activate {
                    background-color: #e8f5e9;
                    color: #2e7d32;
                }
                .status-decline {
                    background-color: #ffebee;
                    color: #c62828;
                }
            `}</style>
        </div>
    );
};

export default UserRegisterMemberListLayer;
